module.exports = __webpack_public_path__ + "img/logo17.a58cc6b9.png";